import { ADMIN_SIGN_IN_PATH } from "@/shared/routes/adminAccess";

export const PARTICIPATION_INVITATION_PATH = "/creator-platform/:creatorNetworkId/campaigns/:campaignId/invitation";

/** The read-only pitch an admin shares with an external creator platform (the link is the token). */
export const EXTERNAL_INVITATION_LINK_PATH = "/creator-platform/invitation/:token";

/** Where a signed-out creator-platform user signs in on the way back to `returnPath`. */
export const getAdminSignInReturnPath = (returnPath: string) =>
  `${ADMIN_SIGN_IN_PATH}?${new URLSearchParams({ returnTo: returnPath }).toString()}`;

export const getParticipationInvitationPath = ({
  creatorNetworkId,
  campaignId,
  decisionToken,
}: {
  creatorNetworkId: string;
  campaignId: string;
  decisionToken?: string;
}) => {
  const path = `/creator-platform/${encodeURIComponent(creatorNetworkId)}/campaigns/${encodeURIComponent(campaignId)}/invitation`;
  return decisionToken ? `${path}?${new URLSearchParams({ decisionToken }).toString()}` : path;
};
